export const DEFAULT_START_DATE_OFFSET = 2;
